import React, { useEffect, useRef, useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo7/aahh.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments, faPen, faEraser } from "@fortawesome/free-solid-svg-icons";
import { modulo7 } from "../../../routes/Module7";
import Sidebar from "../Sidebar";
import { ReactSketchCanvas } from "react-sketch-canvas";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo7/Actividad 6.mp3";

const styles = {
  border: "1px solid #9c9c9c",
  borderRadius: "0",
  height: 320,
};

const Actividad6 = () => {
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo7.content[0];
  const infoAct = modulo7.content[0].activities[5];
  const crumbs = [
    {
      title: modulo7.title,
      url: "/" + modulo7.url,
    },
    {
      title:
        modulo7.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo7.content[0].activities[6].name}`,
    linkNext: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[6].path}`,
    titlePrev: `${modulo7.content[0].activities[4].name}`,
    linkPrev: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo7.color,
    title: `${modulo7.title} - ${infoAct.name}`,
    name: modulo7.title,
  };
  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo7.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="my-5">
        <li>
          Es deber del Estado que todos los peruanos y peruanas reciban
          educación. Con un compañero, compañera o familiar, escojan dónde
          pondrían la escuela en este poblado y dibújenla.
        </li>
      </ul>

      <div className="row my-3 align-items-center">
        <div className="col-md-6 col-xs-12">
          <img src={Imagen1} alt="Libertador" className="img-fluid" />
        </div>
        <div className="col-md-6 col-xs-12">
          <ReactSketchCanvas
            ref={canvasEl}
            style={styles}
            width="600"
            height="860"
            strokeWidth={4}
            strokeColor="red"
          />
          <div className="d-flex mt-1 justify-content-end w-100">
            <button
              onClick={activateEraser}
              className={`btn btn-green me-1 ${
                eraseMode ? "active" : "inactive"
              }`}
            >
              Borrador <FontAwesomeIcon icon={faEraser} />
            </button>
            <button
              onClick={activatePen}
              className={`btn btn-green me-1 ${
                penMode ? "active" : "inactive"
              }`}
            >
              Lapiz <FontAwesomeIcon icon={faPen} />
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen la imagen y vean posibles lugares donde
          construir la escuela.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
